import React, { useEffect, useState } from 'react';
import { Label } from 'react-aria-components';

type Props = {
  label?: string;
  buttonText: string;
  required?: boolean;
  setFile: (v: File | undefined) => void;
  initialValue?: string | null;
  canPreview?: boolean;
  canDelete?: boolean;
  disabled?: boolean;
  accept: 'image/*' | 'text/csv';
};

const FileUpload = (props: Props) => {
  const [objectURL, setObjectURL] = useState(props.initialValue ?? '');
  const [fileName, setFileName] = useState('');
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    if (files && files[0]) {
      // setFileName(files[0].name);
      // props.setFile(files[0]);
      // setObjectURL(URL.createObjectURL(files[0]));
      try {
        setFileName(files[0].name || 'photo.jpg');

        // 画像をBlobとして取得し直す
        const response = await fetch(URL.createObjectURL(files[0]));
        const blob = await response.blob();

        // 新しいFileオブジェクトを作成
        const newFile = new File([blob], files[0].name || 'photo.jpg', {
          type: files[0].type || 'image/jpeg',
          lastModified: new Date().getTime(),
        });

        console.log('新しいファイル情報:', newFile);
        props.setFile(newFile);
        setObjectURL(URL.createObjectURL(newFile));
      } catch (error) {
        console.error('ファイル処理エラー:', error);
      }
    }
  };

  useEffect(() => {
    if (props.initialValue) {
      setObjectURL(props.initialValue);
    }
  }, [props.initialValue]);

  return (
    <div className="relative mb-2 w-full md:w-max">
      {props.label && (
        <div className="flex flex-row">
          <Label className="mb-2 text-base font-bold md:text-lg">{props.label}</Label>
          {props.required && <span className="mb-2 ml-1 text-red-800">※必須</span>}
        </div>
      )}
      <div className="flex flex-col gap-4 md:flex-row md:items-center">
        {props.accept === 'image/*' && (
          <div className="flex items-center gap-2 text-gray-600">
            <FileIcon />
            {objectURL ? (
              <a
                href={objectURL}
                target="_blank"
                rel="noreferrer"
                className="text-base underline md:text-lg"
              >
                {fileName ? fileName : 'アップロード済み画像'}
              </a>
            ) : (
              <span className="text-base">ファイル名.jpg</span>
            )}
          </div>
        )}

        <label
          className={`${props.disabled ? 'cursor-not-allowed border-gray-300 text-gray-400' : 'cursor-pointer border-blue-800 text-blue-600 hover:text-blue-700'} mb-2 flex items-center gap-2 rounded-md border px-4 py-1 md:py-2`}
        >
          <UploadIcon />
          <span className="text-base">{props.buttonText}</span>
          <input
            type="file"
            onChange={handleFileChange}
            className="hidden"
            accept={props.accept}
            disabled={props.disabled}
          />
        </label>
      </div>
      {props.canPreview && objectURL && (
        <div className="mt-2 max-w-md md:mt-0">
          <img
            className="h-auto w-full object-contain"
            src={objectURL}
            alt={'sealRegistrationImage'}
            style={{ maxHeight: '300px' }}
          />
        </div>
      )}
    </div>
  );
};

export default FileUpload;

export const FileIcon = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.76447 0L0.0854492 5.67871V20H15.9143V0H5.76447ZM14.6015 18.687H1.3985V6.44496H6.53072V1.31277H14.6015V18.687Z"
        fill="#4B4B4B"
      />
      <path
        d="M11.8513 9.30005H4.14795V10.3116H11.8513V9.30005Z"
        fill="#4B4B4B"
      />
      <path
        d="M11.8513 12.0623H4.14795V13.0738H11.8513V12.0623Z"
        fill="#4B4B4B"
      />
      <path
        d="M11.8513 14.8247H4.14795V15.8363H11.8513V14.8247Z"
        fill="#4B4B4B"
      />
    </svg>
  );
};

export const UploadIcon = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0208 6.587C15.028 6.49545 15.0327 6.4032 15.0327 6.30979C15.0327 4.36801 13.4586 2.79388 11.5168 2.79388C10.9184 2.79388 10.3551 2.94379 9.86189 3.20746C9.32977 1.70865 7.89982 0.63501 6.21854 0.63501C4.08354 0.63501 2.35276 2.36579 2.35276 4.50079C2.35276 4.90213 2.41397 5.28917 2.52749 5.65314C1.0478 6.23561 0 7.67646 0 9.36297C0 11.5647 1.78485 13.3495 3.98658 13.3495H14.2748C14.381 13.3595 14.4885 13.3652 14.5973 13.3652C16.4766 13.3652 18 11.8418 18 9.96249C18 8.22676 16.7001 6.79562 15.0208 6.587ZM10.9585 8.41435H10.2395C10.027 8.41435 9.85317 8.5882 9.85317 8.80072V10.8424C9.85317 11.0549 9.67929 11.2287 9.46684 11.2287H8.53316C8.32068 11.2287 8.14683 11.0549 8.14683 10.8424V8.80072C8.14683 8.58823 7.97298 8.41435 7.7605 8.41435H7.04148C6.829 8.41435 6.76023 8.27583 6.88866 8.10656L8.76649 5.63138C8.89488 5.46207 9.10508 5.46207 9.23351 5.63138L11.1113 8.10656C11.2398 8.27587 11.171 8.41435 10.9585 8.41435Z"
        fill="#0017C1"
      />
    </svg>
  );
};
